import { FC } from "react";
import { IconProps } from "./types";

export const SocialYoutubeFilled: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path d="M10.09 8.657v6.685L14.865 12 10.09 8.657z" fill={fill} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm6.895-16.491c.414.417.645.982.643 1.57.073.975.098 1.949.101 2.922.003.973-.029 1.947-.102 2.92a2.217 2.217 0 0 1-2.207 2.228c-1.74.073-3.516.107-5.33.103a118.23 118.23 0 0 1-5.332-.103 2.217 2.217 0 0 1-2.207-2.227A39.122 39.122 0 0 1 4.36 12c0-.974.03-1.947.102-2.922a2.218 2.218 0 0 1 2.207-2.227c1.741-.072 3.519-.107 5.332-.104 1.817-.005 3.594.03 5.331.104.588.003 1.15.24 1.564.657z"
      fill={fill}
    />
  </svg>
);
